import { Component, Input, Output, EventEmitter } from '@angular/core';

import { AuthService } from '../../auth';
import { TypePermission } from '../shared/context.enum';
import { DetailedContext } from '../shared/context.interface';

@Component({
  selector: 'igo-context-item',
  template: require('./context-item.component.html'),
  styles: [require('./context-item.component.styl')]
})
export class ContextItemComponent {
  public typePermission = TypePermission;
  public color: string = 'primary';
  public collapsed: boolean = true;

  @Input()
  get context(): DetailedContext { return this._context; }
  set context(value: DetailedContext) {
    this._context = value;
  }
  private _context: DetailedContext;

  @Input()
  get default(): boolean { return this._default; }
  set default(value: boolean) {
    this._default = value;
  }
  private _default: boolean = false;

  @Output() edit = new EventEmitter<DetailedContext>();
  @Output() delete = new EventEmitter<DetailedContext>();
  @Output() save = new EventEmitter<DetailedContext>();
  @Output() clone = new EventEmitter<DetailedContext>();
  @Output() favorite = new EventEmitter<DetailedContext>();
  @Output() managePermissions = new EventEmitter<DetailedContext>();
  @Output() manageTools = new EventEmitter<DetailedContext>();

  constructor(public auth: AuthService) {}

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/context/context-item/context-item.component.ts